import {
  FETCH_CUSTOMER_LIST,
  FETCH_CUSTDETAIL_LIST,
  FETCH_All_Account_Manager,
  FETCH_Muvi_Account_Manager,
  FETCH_All_Muvi_Six,
  FETCH_Muvi_Six_Customer,
  FETCH_Customers_For_Search,
  FETCH_Muvi_Six_Customer_SearchHandler,
  FETCH_Load_More,
  FETCH_Load_More1,
  FETCH_Pagination_Handel,
  FETCH_Muvi6_Login,
  FETCH_Assign_Acc,
  FETCH_Save_Account_Manager,
  FETCH_Savepassword,
  FETCH_CancelAccountMuvi5,
  FETCH_Raise_Invoice,
  FETCH_Product_By_Key,
  FETCH_Muvi_Classic_Count,
} from "./type";
import * as actionFunction from "./common";

function getCustomers(post) {
  post.page === "" ? 1 : post.page;
  var commonStateData = actionFunction.commonData();
  commonStateData["page"] = post.page;
  commonStateData["search"] = post.search;
  commonStateData["keyaccount"] = post.keyaccount;
  commonStateData["pagination"] = post.pagination;

  return (dispatch) => {
    fetch(
      commonStateData.apiUrl +
        "/adminRest/getCustomers/page/" +
        commonStateData.page +
        "/userId/" +
        commonStateData.userId +
        "/userAuthKey/" +
        commonStateData.userAuthKey,
      {
        method: "POST",
        dataType: "json",
        body: JSON.stringify(commonStateData),
      }
    )
      .then((Response) => Response.json())
      .then((findresponse) => {
        findresponse = actionFunction.rawjsonparse(findresponse, 1);
        if (commonStateData.pagination == 1) {
          dispatch({
            type: FETCH_CUSTOMER_LIST,
            customers: findresponse.customers,
            offset: findresponse.offset,
            off_count: findresponse.off_count,
            item_count: findresponse.item_count,
            //                            store_permission: findresponse.store_permission,
            //                            customer_success_permission: findresponse.customer_success_permission,
            //                            is_general_user: findresponse.is_general_user
          });
        } else {
          dispatch({
            type: FETCH_CUSTOMER_LIST,
            customers: findresponse.customers,
            item_count: findresponse.item_count,
            //                            muviFiveCount: findresponse.item_count,
            //                            store_permission: findresponse.store_permission,
            //                            customer_success_permission: findresponse.customer_success_permission,
            //                            is_general_user: findresponse.is_general_user,
            package: findresponse.package,
            offset: findresponse.offset,
            off_count: findresponse.off_count,
            setPage: "yes",
            muvisixproductkey: "",
            search: "",
          });
        }
      });
  };
}
function customer_details(studio_id, studio_name, user_id) {
  document.getElementById("new_password").value = "";
  var commonStateData = actionFunction.commonData();
  return (dispatch) => {
    fetch(
      commonStateData.apiUrl +
        "/AdminRest/customerdetails/studio_id/" +
        studio_id +
        "/user_id/" +
        user_id +
        "/userAuthKey/" +
        commonStateData.userAuthKey,
      {
        method: "POST",
        dataType: "json",
        body: JSON.stringify(commonStateData),
      }
    )
      .then((Response) => Response.json())
      .then((findresponse) => {
        findresponse = actionFunction.rawjsonparse(findresponse, 1);
        dispatch({
          type: FETCH_CUSTDETAIL_LIST,
          studio_id: findresponse.studio_id,
          studio_id_id: findresponse.studio_id.id,
          user_id_id: findresponse.user_id.id,
          studio_id_name: findresponse.studio_id.name,
          user_id_email: findresponse.user_id.email,
          studio_email: findresponse.user_id.email,
          user_id: findresponse.user_id,
          id: findresponse.id ? findresponse.id : "",
          account_manager: findresponse.account_manager,
        });
      });
  };
}

function getAllAccountManager() {
  var commonStateData = actionFunction.commonData();
  return (dispatch) => {
    fetch(
      commonStateData.apiUrl +
        "/adminRest/getAllEmployee/userAuthKey/" +
        commonStateData.userAuthKey,
      {
        method: "GET",
        //            headers: {
        //                'content-type': 'application/json'
        //            }
      }
    )
      .then((Response) => Response.json())
      .then((data) => {
        dispatch({
          type: FETCH_All_Account_Manager,
          allEmployee: data,
        });
      });

    fetch(
      commonStateData.apiUrl +
        "/adminRest/allMuviSixAccountManager/userAuthKey/" +
        commonStateData.userAuthKey,
      {
        method: "GET",
        //            headers: {
        //                'content-type': 'application/json'
        //            }
      }
    )
      .then((Response) => Response.json())
      .then((datas) => {
        dispatch({
          type: FETCH_Muvi_Account_Manager,
          allMuviAccountManager: datas,
        });
      })
      .catch((err) => console.log(err.message));
  };
}

function allmuvisixfunc() {
  var commonStateData = actionFunction.commonData();
  return (dispatch) => {
    const customer_section = { customer_section: 1 };
    fetch(
      commonStateData.apiUrl +
        "/RevenueRest/activeProductStatistics/userAuthKey/" +
        commonStateData.userAuthKey,
      {
        method: "POST",
        body: JSON.stringify(customer_section),
      }
    )
      .then((Response) => Response.json())
      .then((data) => {
        dispatch({
          type: FETCH_All_Muvi_Six,
          allmuvisix: data.data,
        });
      })
      .catch((err) => console.log(err.message));
  };
}
function getMuvisixCustomerActn(value) {
  return (dispatch) => {
    fetch("https://apigateway.muvi.com/customer-list", {
      method: "POST",
      dataType: "json",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        query: `{getCustomerList( product_key: "${value}", type: \"Customer\", page: 0, size: 20) {page_info{total_count}, user_details {username,country_name, name, email, mobile, company_name, ip_address, address, product_name, user_uuid, user_status, profile_image_url, created_date, deleted_date, app_token, onhold_period, canceled_date, cancellation_reason, canceled_by, custom_cancellation_reason, free_trial_expiry_date, package_name, card_last_four_digits, package_summary, package_period, package_price, total_revenue, next_subscription_date, last_transaction_amount, last_transaction_date, account_status, deleted_reason, deleted_by, plan_period, plan_price, plan_name, currency_code, source,store_key,domain_name, is_enterprise , enterprise_api_gateway_url}}}`,
      }),
    })
      .then((Response) => Response.json())
      .then((findresponse) => {
        //            console.log('tst',findresponse.data.getCustomerList.user_details);
        dispatch({
          type: FETCH_Muvi_Six_Customer,
          customers: findresponse.data.getCustomerList.user_details,
          item_count: findresponse.data.getCustomerList.page_info.total_count,
          //                        offset: findresponse.data.getCustomerList.offset,
          muvisixproductkey: value,
        });
      })
      .catch((err) => console.log(err.message));
  };
}

function muvisixCustomerSearchHandler(muvisixproductkey, search) {
  return (dispatch) => {
    fetch("https://apigateway.muvi.com/customer-list", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        query: `{getCustomerList( product_key: "${muvisixproductkey}", type: "Customer", page: 0, size: 20, search : \"${search}") {page_info{total_count}, user_details {username,country_name, name, email, mobile, company_name, ip_address, address, product_name, user_uuid, user_status, profile_image_url, created_date, deleted_date, app_token, onhold_period, canceled_date, cancellation_reason, canceled_by, custom_cancellation_reason, free_trial_expiry_date, package_name, card_last_four_digits, package_summary, package_period, package_price, total_revenue, next_subscription_date, last_transaction_amount, last_transaction_date, account_status, deleted_reason, deleted_by, plan_period, plan_price, plan_name, currency_code, source,store_key, domain_name, is_enterprise , enterprise_api_gateway_url}}}`,
      }),
    })
      .then((Response) => Response.json())
      .then((data) => {
        dispatch({
          type: FETCH_Muvi_Six_Customer_SearchHandler,
          customers: data.data.getCustomerList.user_details,
          item_count: data.data.getCustomerList.page_info.total_count,
        });
      })
      .catch((ee) => console.log(ee.message));
    //    })
  };
}

function loadMoreAct(pageNumber) {
  var commonStateData = actionFunction.commonData();
  return (dispatch) => {
    fetch(
      commonStateData.apiUrl +
        "/adminRest/getCustomers/page/" +
        pageNumber +
        "/userId/" +
        commonStateData.userId +
        "/userAuthKey/" +
        commonStateData.userAuthKey,
      {
        method: "POST",
        dataType: "json",
        body: JSON.stringify(commonStateData),
      }
    )
      .then((Response) => Response.json())
      .then((findresponse) => {
        findresponse = actionFunction.rawjsonparse(findresponse, 1);
        if (findresponse.customers.length == 0) {
          dispatch({
            type: FETCH_Load_More1,
            isLoadMore: 2,
          });
        } else {
          dispatch({
            type: FETCH_Load_More1,
            isLoadMore: 1,
          });
        }
        dispatch({
          type: FETCH_Load_More,
          customers: this.state.customers.concat(findresponse.customers),
        });
      });
  };
}

function paginationHandel(post) {
  var commonStateData = actionFunction.commonData();
  commonStateData["muvisixproductkey"] = post.muvisixproductkey;
  commonStateData["pageNumber"] = post.pageNumber;
  commonStateData["search"] = post.search;
  commonStateData["offset"] = post.offset;
  return (dispatch) => {
    fetch("https://apigateway.muvi.com/customer-list", {
      method: "POST",
      dataType: "json",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        query: `{getCustomerList( product_key: "${
          commonStateData.muvisixproductkey
        }", type: "Customer", page: ${
          commonStateData.pageNumber - 1
        }, search: \"${
          commonStateData.search
        }", size: 20) {page_info{total_count}, user_details {username,country_name, name, email, mobile, company_name, ip_address, address, product_name, user_uuid, user_status, profile_image_url, created_date, deleted_date, app_token, onhold_period, canceled_date, cancellation_reason, canceled_by, custom_cancellation_reason, free_trial_expiry_date, package_name, card_last_four_digits, package_summary, package_period, package_price, total_revenue, next_subscription_date, last_transaction_amount, last_transaction_date, account_status, deleted_reason, deleted_by, plan_period, plan_price, plan_name, currency_code, source, store_key, domain_name, is_enterprise , enterprise_api_gateway_url}}}`,
      }),
    })
      .then((Response) => Response.json())
      .then((findresponse) => {
        dispatch({
          type: FETCH_Pagination_Handel,
          customers: findresponse.data.getCustomerList.user_details,
          item_count: findresponse.data.getCustomerList.page_info.total_count,
          //                        offset: findresponse.data.getCustomerList.offset,
        });
      });
  };
}
function goToCustomerStore(email, password, studio_id, studio_name) {
  var commonStateData = actionFunction.commonData();
  return (dispatch) => {
    if (
      window.confirm("Are you sure to login this store '" + studio_name + "' ?")
    ) {
      var win = window.open(
        commonStateData.studioUrl +
          "/login/storeLogin" +
          "?email=" +
          email +
          "&password=" +
          password +
          "&studio_id=" +
          studio_id,
        "_blank"
      );
      win.focus();
    }
  };
}

function userDataEncryptMuvi6(productkey, userid, uname) {
  var commonStateData = actionFunction.commonData();
  return (dispatch) => {
    if (window.confirm("Are you sure to login this store '" + uname + "' ?")) {
      const loginDetails = {
        product_key: `${productkey}`,
        user_uuid: `${userid}`,
        //                 product_key: '8E4F8A19B07D4F22927CD4CB54672D27',
        //                 user_uuid: '0c8920cc75ec40f4ac0724227a940d85',
        muvi_user_uuid: "17325ad1c482fa796bfbea34d7157",
      };
      fetch(
        commonStateData.apiUrl +
          "/adminRest/encData/userAuthKey/" +
          commonStateData.userAuthKey,
        {
          method: "POST",
          body: JSON.stringify(loginDetails),
        }
      )
        .then((Response) => Response.json())
        .then((findresponse) => {
          findresponse = actionFunction.rawjsonparse(findresponse, 1);
          dispatch({
            type: FETCH_Muvi6_Login,
            user_data: findresponse,
          });

          fetch(commonStateData.apiUrl + "/AdvancedRest/getintraLogin", {
            method: "POST",
            //                    headers: {
            //                        "content-type": 'application/json'
            //                    },
            body: JSON.stringify(findresponse),
          })
            .then((Response) => Response.json())
            .then((data) => {
              const dat = actionFunction.rawjsonparse(data, 1);
              const data_login = JSON.parse(dat);

              if (data_login.status == "SUCCESS") {
                const REDIRECT_URL = `https://account.muvi.com`;
                window.open(
                  `${REDIRECT_URL}/autologin?continue=${data_login.data.product_cms_full_url}&token=${data_login.response.refresh_token}&isIntranet = true`,
                  "_blank"
                );
                //                                  window.open(`${data_login.data.urlEndPoint}`, '_blank');
              }
            });
        });
    }
  };
}

function assignMuvi6AccountManager(data) {
  var commonStateData = actionFunction.commonData();
  return (dispatch) => {
    fetch(
      commonStateData.apiUrl +
        "/adminRest/assignAccountManager/userAuthKey/" +
        commonStateData.userAuthKey,
      {
        method: "POST",
        //            headers: {
        //
        //                'content-type': 'application/json'
        //            },
        dataType: "json",
        body: JSON.stringify(data),
      }
    )
      .then((Response) => Response.json())
      .then((data) => {
        dispatch({
          type: FETCH_Assign_Acc,
          mssg: "assign",
        });
        // document.querySelector("body").classList.remove('modal-open');
        // this.getAllAccountManager();
      });
  };
}

function removeAccountManager_muvi6(company_name, apptoken, productkey, email) {
  var commonStateData = actionFunction.commonData();
  return (dispatch) => {
    const fd = new FormData();
    fd.append("studio_name", company_name);
    fd.append("apptoken", apptoken);
    fd.append("productkey", productkey);
    fd.append("email", email);
    fetch(
      commonStateData.apiUrl +
        "/AdminRest/removeAccountManager_muvi6/userAuthKey/" +
        commonStateData.userAuthKey,
      {
        method: "POST",
        dataType: "json",
        body: fd,
      }
    )
      .then((Response) => Response.json())
      .then((findresponse) => {
        dispatch({
          type: FETCH_Assign_Acc,
          mssg: "assign",
        });
        // window.location.href = '/customers';
      });
  };
}

function RemoveAccountManagerMuvi5(studio_name, studio_id, studio_email) {
  // in case of muvi5 appToken is studio_id
  var commonStateData = actionFunction.commonData();
  return (dispatch) => {
    const fd = new FormData();
    fd.append("studio_name", studio_name);
    fd.append("studio_id", studio_id);
    fd.append("studio_email", studio_email);
    fetch(
      commonStateData.apiUrl +
        "/AdminRest/RemoveAccountManagerMuvi5/userAuthKey/" +
        commonStateData.userAuthKey,
      {
        method: "POST",
        dataType: "json",
        body: fd,
      }
    )
      .then((Response) => Response.json())
      .then((findresponse) => {
        dispatch({
          type: FETCH_Assign_Acc,
          mssg: "assign",
        });
      });
    // window.location.href = '/customers';
  };
}

function SaveAccountManager(studio_id, user_id, id, studio_name, studio_email) {
  var commonStateData = actionFunction.commonData();
  return (dispatch) => {
    const fd = new FormData();
    fd.append("studio_name", studio_name);
    fd.append("studio_email", studio_email);
    fetch(
      commonStateData.apiUrl +
        "/AdminRest/saveAccountManager/studio_id/" +
        studio_id +
        "/user_id/" +
        user_id +
        "/account_id/" +
        id +
        "/userAuthKey/" +
        commonStateData.userAuthKey,
      {
        method: "POST",
        dataType: "json",
        // body: JSON.stringify(commonStateData),
        body: fd,
      }
    )
      .then((Response) => Response.json())
      .then((findresponse) => {
        dispatch({
          type: FETCH_Save_Account_Manager,
          mssg: "accmngrassign",
        });
        // window.location.href = '/customers';
      });
  };
}

function Savepassword(studio_id, user_id, pwd = "") {
  var commonStateData = actionFunction.commonData();
  return (dispatch) => {
    fetch(
      commonStateData.apiUrl +
        "/AdminRest/Savepassword/studio_id/" +
        studio_id +
        "/user_id/" +
        user_id +
        "/new_password/" +
        pwd +
        "/userAuthKey/" +
        commonStateData.userAuthKey,
      {
        method: "POST",
        dataType: "json",
        body: JSON.stringify(commonStateData),
      }
    )
      .then((Response) => Response.json())
      .then((findresponse) => {
        findresponse = actionFunction.rawjsonparse(findresponse, 1);
        if (findresponse.code == 200) {
          dispatch({
            type: FETCH_Savepassword,
            message: "",
          });
          document.getElementById("changePassword").style.display = "none";
          document.querySelector("body").classList.remove("modal-open");
          window.location.href = "/customers";
        } else {
          dispatch({
            type: FETCH_Savepassword,
            message: findresponse.msg,
          });
        }
      });
  };
}

function CancelAccountMuvi5(
  studio_id,
  user_id,
  custom_notes = "",
  is_charged = ""
) {
  var commonStateData = actionFunction.commonData();
  return (dispatch) => {
    fetch(
      commonStateData.apiUrl +
        "/AdminRest/CancelAccountForCustomers/studio_id/" +
        studio_id +
        "/user_id/" +
        user_id +
        "/custom_notes/" +
        custom_notes +
        "/is_charged/" +
        is_charged +
        "/userAuthKey/" +
        commonStateData.userAuthKey,
      {
        method: "POST",
        dataType: "json",
        body: JSON.stringify(commonStateData),
      }
    )
      .then((Response) => Response.json())
      .then((findresponse) => {
        findresponse = actionFunction.rawjsonparse(findresponse, 1);
        if (findresponse.code == 200) {
          dispatch({
            type: FETCH_CancelAccountMuvi5,
            message1: "",
          });
          document.getElementById("cancelAccount").style.display = "none";
          document.querySelector("body").classList.remove("modal-open");
          window.location.href = "/customers";
        } else {
          dispatch({
            type: FETCH_CancelAccountMuvi5,
            message1: findresponse.msg,
          });
        }
      });
  };
}

function fetchProductByKey(key, pageNumber = 0) {
  return (dispatch) => {
    fetch("https://apigateway.muvi.com/customer-list", {
      method: "POST",
      dataType: "json",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        query: `{getCustomerList( product_key: "${key}", type: \"Customer\", page: ${pageNumber}, size: 20) {page_info{total_count}, user_details {username,country_name, name, email, mobile, company_name, ip_address, address, product_name, user_uuid, user_status, profile_image_url, created_date, deleted_date, app_token, onhold_period, canceled_date, cancellation_reason, canceled_by, custom_cancellation_reason, free_trial_expiry_date, package_name, card_last_four_digits, package_summary, package_period, package_price, total_revenue, next_subscription_date, last_transaction_amount, last_transaction_date, account_status, deleted_reason, deleted_by, plan_period, plan_price, plan_name, currency_code, source,store_key, domain_name, is_enterprise , enterprise_api_gateway_url}}}`,
      }),
    })
      .then((Response) => Response.json())
      .then((findresponse) => {
        dispatch({
          type: FETCH_Product_By_Key,
          customers: findresponse.data.getCustomerList.user_details,
          item_count: findresponse.data.getCustomerList.page_info.total_count,
        });
      });
  };
}

function raiseInvoice(
  item_name,
  item_description,
  invoice_amount,
  productkey,
  userid,
  activePage,
  enterprise_api_gateway_url
) {
  var commonStateData = actionFunction.commonData();
  const loginDetails = {
    product_key: `${productkey}`,
    user_uuid: `${userid}`,
    muvi_user_uuid: "17325ad1c482fa796bfbea34d7157",
    item_name: `${item_name}`,
    item_description: `${item_description}`,
    invoice_amount: `${invoice_amount}`,
    enterprise_api_gateway_url: `${enterprise_api_gateway_url}`,
  };
  return (dispatch) => {
    fetch(
      commonStateData.apiUrl +
        "/adminRest/raiseCustomInvoice/userAuthKey/" +
        commonStateData.userAuthKey,
      {
        method: "POST",
        //            headers: {
        //                'content-type': 'application/json'
        //            },
        dataType: "json",
        body: JSON.stringify(loginDetails),
      }
    )
      .then((Response) => Response.json())
      .then((data) => {
        window.$("#raiseInvoiceModal").modal("hide");
        if (data.code == 200) {
          dispatch({
            type: FETCH_Raise_Invoice,
            code: data.code,
            message: data.message,
          });
          document.getElementById("raiseInvoiceModal").style.display = "none";
          document.querySelector("body").classList.remove("modal-open");
          //                this.fetchProductByKey(productkey, activePage);
        } else {
          dispatch({
            type: FETCH_Raise_Invoice,
            message: data.message,
          });
        }
        document.getElementById("submit_invoice").innerHTML = "Submit Invoice";
        document.getElementById("submit_invoice").disabled = false;
      });
  };
}

function getMuviClassicCount() {
  const customer_type = { type: 1 };
  return (dispatch) => {
    fetch("https://cms.muvi.com/intranet/getMuvi5TotalCounts", {
      method: "POST",
      dataType: "json",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(customer_type),
    })
      .then((Response) => Response.json())
      .then((findresponse) => {
        findresponse = actionFunction.rawjsonparse(findresponse, 1);
        dispatch({
          type: FETCH_Muvi_Classic_Count,
          muviFiveCount: findresponse.total_count,
        });
      });
  };
}

export {
  getCustomers,
  customer_details,
  getAllAccountManager,
  allmuvisixfunc,
  getMuvisixCustomerActn,
  muvisixCustomerSearchHandler,
  loadMoreAct,
  paginationHandel,
  goToCustomerStore,
  userDataEncryptMuvi6,
  assignMuvi6AccountManager,
  SaveAccountManager,
  removeAccountManager_muvi6,
  RemoveAccountManagerMuvi5,
  Savepassword,
  CancelAccountMuvi5,
  raiseInvoice,
  fetchProductByKey,
  getMuviClassicCount,
};



// WEBPACK FOOTER //
// ./src/actions/customerListAction.js